/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content, no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import $ from 'jquery';
import {
  Dropdown,
  MenuItem,
} from '@bingads-webui-react/primitive-unthemed';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';
import { ImageExperienceImage } from '../model/image-experience-image';
import { PlaceHolderImage } from './place-holder-image';
import C from '../constants';
import { showDisabledReasonCallout, hideDisabledReasonCallout } from '../util/callout-disabled-edit';

export class ImageListView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.disabledContainerRef = React.createRef();
  }

  componentDidMount() {
    $('.not-recroppable').on('mouseenter', this.showDisabledReasonHandler);
    $('.not-recroppable').on('click', this.showDisabledReasonHandler);
    $('.not-recroppable').on('mouseleave', this.hideDisabledReasonHandler);
  }

  onEditSelect = (eventKey, event) => {
    const imageType = event.target.parentNode.parentNode.dataset.imagetype;

    switch (eventKey) {
      case 'replace':
        this.props.onReplaceImage(imageType);
        break;

      case 're-crop':
      default:
        this.props.onReCropImage(imageType);
        break;
    }
  };

  onAddImage = (imageType) => {
    this.props.onReplaceImage(imageType);
  };

  showDisabledReasonHandler = (event) => {
    if (event.target.className !== 'not-recroppable disabled') {
      return;
    }
    const { i18n } = this.props;
    showDisabledReasonCallout(i18n, event, this.disabledContainerRef.current);
  };

  hideDisabledReasonHandler = () => {
    hideDisabledReasonCallout(this.disabledContainerRef.current);
  };

  render() {
    const {
      isMultimediaAd,
      permissions,
      readOnly,
      isCombinedMsanAndMmaAspectRatios,
      isStoreAppProng,
      isStoreAppSpotLight,
      isStoreAppTransparentLogo,
      isLinkedInAd,
      isPMaxAspectRatiosV2Enabled,
      isAdPreviewRefreshEnabled,
    } = this.props;

    return (
      <div className="image-list-view-content">
        <div className="image-list clearfix">
          <div>
            <span className="image-list-label">
              {this.props.i18n.getString('ImageExperience_Image_List_Label')}
            </span>
            <HelpPopup
              topic="pop_BA_ImageAssets_ImageExt"
              aria-label={this.props.i18n.getString('Click to learn more about {{item}}', { item: this.props.i18n.getString('ImageExperience_Image_List_Label') })}
            />
          </div>
          <div className="image-list-content">
            {
              C.getImageTypesWithOrder(isMultimediaAd, isCombinedMsanAndMmaAspectRatios, isStoreAppProng, isStoreAppSpotLight, isStoreAppTransparentLogo, isLinkedInAd, isPMaxAspectRatiosV2Enabled, isAdPreviewRefreshEnabled).map((imageType) => {
                const imageItem =
                  _.find(this.props.imageList, imageListImg => imageListImg.Type === imageType);

                if (imageItem) {
                  return (
                    <div
                      className="image-list-item"
                      key={imageItem.Type}
                    >
                      <div className="image-list-item-image">
                        <CroppedImageView
                          resizeImageHeight={C.resizeImageHeightInList}
                          src={imageItem.Src}
                          originalWidth={imageItem.Width}
                          originalHeight={imageItem.Height}
                          SourceX={imageItem.CropSettings.SourceX}
                          SourceY={imageItem.CropSettings.SourceY}
                          SourceWidth={imageItem.CropSettings.SourceWidth}
                          SourceHeight={imageItem.CropSettings.SourceHeight}
                          aspectRatio={C.aspectRatios[imageItem.Type].aspectRatio}
                        />
                        <Dropdown
                          className="image-edit-dropdown"
                          onSelect={this.onEditSelect}
                        >
                          <Dropdown.Toggle aria-label={this.props.i18n.getString('ImageExperience_Edit_Image_Label', {
                              // eslint-disable-next-line max-len
                              ratio: this.props.i18n.getString(C.aspectRatios[imageItem.Type].stringKey),
                            })}
                          >
                            { !this.props.isForVNext && this.props.i18n.getString('Audience_Campaign_Crud_Ad_EditAd')}
                          </Dropdown.Toggle>
                          <Dropdown.Menu data-imagetype={imageItem.Type}>
                            <MenuItem
                              eventKey="re-crop"
                              disabled={_.isNull(imageItem.id) || permissions.IsReadOnlyUser || readOnly}
                              className={_.isNull(imageItem.id) ? 'not-recroppable' : 'recroppable'}
                            >
                              {this.props.i18n.getString('ImageEditor_CropImage')}
                            </MenuItem>
                            <MenuItem eventKey="replace" disabled={permissions.IsReadOnlyUser || readOnly}>
                              {this.props.i18n.getString('ImageExperience_Replace')}
                            </MenuItem>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className="image-item-ratio-label">
                        {this.props.i18n.getString(C.aspectRatios[imageItem.Type].stringKey)}
                      </div>
                    </div>
                  );
                }
                return (
                  <PlaceHolderImage
                    i18n={this.props.i18n}
                    onAddImage={this.onAddImage}
                    type={imageType}
                    key={imageType}
                  />
                );
              })
            }
            {
              this.props.isForVNext && <button
                className="remove-all-button"
                onClick={this.props.onRemoveAllImages}
                aria-label={this.props.i18n.getString('ImageExperience_RemoveAllImages')}
              />
            }
          </div>
          <div ref={this.disabledContainerRef} />
        </div>
        {
          !this.props.isForVNext && (
            <button
              className="btn btn-default remove-all-button"
              onClick={this.props.onRemoveAllImages}
            >
              {this.props.i18n.getString('ImageExperience_RemoveAllImages')}
            </button>
          )
        }
      </div>
    );
  }
}

ImageListView.propTypes = {
  imageList: PropTypes.arrayOf(PropTypes.instanceOf(ImageExperienceImage)).isRequired,
  onReplaceImage: PropTypes.func.isRequired,
  onReCropImage: PropTypes.func.isRequired,
  onRemoveAllImages: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  isForVNext: PropTypes.bool,
  isMultimediaAd: PropTypes.bool,
  readOnly: PropTypes.bool,
  permissions: PropTypes.shape({
    IsReadOnlyUser: PropTypes.bool,
  }),
};

ImageListView.defaultProps = {
  isForVNext: false,
  isMultimediaAd: false,
  readOnly: false,
  permissions: {},
};
